// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#slides {
  width: 100%;
  height: 100vh; /* Full height of the viewport */
  top: 0;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.slide.active {
  opacity: 1;
}

.static-content {
  position: absolute;
  bottom: 40%;
  color: #eefcff;
  text-align: center;
  font-size: 5rem; /* Base font size for larger screens */
  white-space: nowrap;
  text-shadow: 0 0 6px rgba(231, 242, 255, 0.645);
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  font-style: normal;
}

.static-content h1 {
  font-size: 75px; /* Base font size for h1 */
  margin-bottom: 10px;
  font-weight: bolder;
  text-align: center;
  color: #004658;
  text-transform: uppercase;
}

.static-content p {
  font-size: 58px; /* Base font size for paragraphs */
  margin-top: 0;
  white-space: wrap;
  text-align: right;
  color: #eefcff;
  width: 70%; /* Maintain some width on larger screens */
  right: 0;
  text-shadow: 0 0 6px #004658;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .static-content {
      font-size: 3rem; /* Adjust font size for medium screens */
      bottom: 30%; /* Raise content position */
  }

  .static-content h1 {
      font-size: 50px; /* Adjust h1 size */
      white-space: wrap;

  }

  .static-content p {
      font-size: 40px; /* Adjust paragraph size */
      width: 80%; /* Allow more width on smaller screens */
      text-align: center; /* Center-align for smaller screens */
  }
}

@media (max-width: 480px) {
  .static-content {
      font-size: 2rem; /* Smaller font size for mobile */
      bottom: 20%; /* Raise content position */
  }

  .static-content h1 {
      font-size: 26px; /* Smaller h1 size */
      white-space: wrap;
      
  }

  .static-content p {
      font-size: 22px; /* Smaller paragraph size */
      width: 80%; /* Full width on mobile */
      text-align: center; /* Center-align for mobile */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/slideshow.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa,EAAE,gCAAgC;EAC/C,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe,EAAE,sCAAsC;EACvD,mBAAmB;EACnB,+CAA+C;EAC/C,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe,EAAE,0BAA0B;EAC3C,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe,EAAE,kCAAkC;EACnD,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,UAAU,EAAE,0CAA0C;EACtD,QAAQ;EACR,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE;MACI,eAAe,EAAE,wCAAwC;MACzD,WAAW,EAAE,2BAA2B;EAC5C;;EAEA;MACI,eAAe,EAAE,mBAAmB;MACpC,iBAAiB;;EAErB;;EAEA;MACI,eAAe,EAAE,0BAA0B;MAC3C,UAAU,EAAE,wCAAwC;MACpD,kBAAkB,EAAE,qCAAqC;EAC7D;AACF;;AAEA;EACE;MACI,eAAe,EAAE,iCAAiC;MAClD,WAAW,EAAE,2BAA2B;EAC5C;;EAEA;MACI,eAAe,EAAE,oBAAoB;MACrC,iBAAiB;;EAErB;;EAEA;MACI,eAAe,EAAE,2BAA2B;MAC5C,UAAU,EAAE,yBAAyB;MACrC,kBAAkB,EAAE,4BAA4B;EACpD;AACF","sourcesContent":["#slides {\n  width: 100%;\n  height: 100vh; /* Full height of the viewport */\n  top: 0;\n}\n\n.slide {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  opacity: 0;\n  transition: opacity 1s ease-in-out;\n}\n\n.slide.active {\n  opacity: 1;\n}\n\n.static-content {\n  position: absolute;\n  bottom: 40%;\n  color: #eefcff;\n  text-align: center;\n  font-size: 5rem; /* Base font size for larger screens */\n  white-space: nowrap;\n  text-shadow: 0 0 6px rgba(231, 242, 255, 0.645);\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 900;\n  font-style: normal;\n}\n\n.static-content h1 {\n  font-size: 75px; /* Base font size for h1 */\n  margin-bottom: 10px;\n  font-weight: bolder;\n  text-align: center;\n  color: #004658;\n  text-transform: uppercase;\n}\n\n.static-content p {\n  font-size: 58px; /* Base font size for paragraphs */\n  margin-top: 0;\n  white-space: wrap;\n  text-align: right;\n  color: #eefcff;\n  width: 70%; /* Maintain some width on larger screens */\n  right: 0;\n  text-shadow: 0 0 6px #004658;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .static-content {\n      font-size: 3rem; /* Adjust font size for medium screens */\n      bottom: 30%; /* Raise content position */\n  }\n\n  .static-content h1 {\n      font-size: 50px; /* Adjust h1 size */\n      white-space: wrap;\n\n  }\n\n  .static-content p {\n      font-size: 40px; /* Adjust paragraph size */\n      width: 80%; /* Allow more width on smaller screens */\n      text-align: center; /* Center-align for smaller screens */\n  }\n}\n\n@media (max-width: 480px) {\n  .static-content {\n      font-size: 2rem; /* Smaller font size for mobile */\n      bottom: 20%; /* Raise content position */\n  }\n\n  .static-content h1 {\n      font-size: 26px; /* Smaller h1 size */\n      white-space: wrap;\n      \n  }\n\n  .static-content p {\n      font-size: 22px; /* Smaller paragraph size */\n      width: 80%; /* Full width on mobile */\n      text-align: center; /* Center-align for mobile */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
